export function init() {
    $('[data-toggle="tooltip"]').tooltip();
}